import { useLayoutEffect, useRef, useState } from "react";
import { Box } from "@mui/material";
import { createUseStyles } from "react-jss";
import Collapsible from "./Collapsible/Collapsible";

const DEFAULT_NOTES_HEIGHT = 100;

type Props = {
  className?: string;
  text?: string;
};

function Notes({ className, text = "Aucun" }: Props) {
  const classes = useStyles();
  const [isReadMoreVisible, setIsReadMoreVisible] = useState(false);
  const ref = useRef(null);

  useLayoutEffect(() => {
    if (ref.current && ref.current.clientHeight >= DEFAULT_NOTES_HEIGHT) {
      setIsReadMoreVisible(true);
    } else {
      setIsReadMoreVisible(false);
    }
  }, [ref, text]);

  return (
    <Collapsible
      defaultHeight={DEFAULT_NOTES_HEIGHT}
      className={className}
      isVisible={isReadMoreVisible}
    >
      <Box display="flex">
        <div className={classes.notesContainer}>
          <p className={classes.notesText} ref={ref} id="notes">
            {text}
          </p>
        </div>
      </Box>
    </Collapsible>
  );
}

const useStyles = createUseStyles({
  notesContainer: {
    flex: 1,
    paddingRight: "10px",
  },
  notesText: {
    whiteSpace: "pre-line",
    lineHeight: "20px",
  },
});

export default Notes;
